// Library imports
import React from "react";

// User Component imports
import { LoadingBox } from "_core/components/common/UI";
import { reloadLabel, formatDemoDate } from "../utils/demoPage";

/**
 * 作成済みデモページの一覧（ログイン中テナントのもの）
 */
const DemoPageList = ({ pages, showLoading, copiedKey, onOpen, onCopy, onEdit }) => (
    <div className="ops-demo-list">
        <div className="ops-demo-list-head">
            <div className="ops-demo-list-heading">
                <div className="ops-demo-list-title">作成済みデモページ</div>
                <div className="ops-demo-list-note">ログイン中のアカウントのテナントで作成されたデモページのみを表示します。</div>
            </div>
            {pages && <span className="ops-demo-list-count">{pages.length} 件</span>}
        </div>

        {!pages ?
            <div className="ops-demo-list-loading">{showLoading && <LoadingBox />}</div>
            :
            <div className="ops-demo-table">
                <div className="ops-demo-tr is-head">
                    <div className="ops-demo-td is-name">ページ名</div>
                    <div className="ops-demo-td is-title">ページタイトル</div>
                    <div className="ops-demo-td is-reload">自動リロード</div>
                    <div className="ops-demo-td is-date">作成日時</div>
                    <div className="ops-demo-td is-actions" />
                </div>
                {pages.map((page) => {
                    const isCopied = copiedKey === page.page_name;
                    return (
                        <div className="ops-demo-tr" key={page.page_name}>
                            <div className="ops-demo-td is-name">
                                <div className="ops-demo-page-name">
                                    {page.page_name}
                                    {page.is_locked && <span className="ops-demo-lock-badge" title="手で書き換えられたページのため、設定変更・削除はできません"><i className="bi bi-lock-fill" />ロック</span>}
                                </div>
                                <div className="ops-demo-page-url">{page.url}</div>
                            </div>
                            <div className={"ops-demo-td is-title" + (page.title ? "" : " is-empty")}>{page.title || "（タイトル未設定）"}</div>
                            <div className={"ops-demo-td is-reload" + (page.reload_sec ? "" : " is-empty")}>{reloadLabel(page.reload_sec)}</div>
                            <div className="ops-demo-td is-date">{formatDemoDate(page.created_at)}</div>
                            <div className="ops-demo-td is-actions">
                                <button type="button" className="ops-demo-icon-btn" title="新しいタブで開きます" onClick={() => onOpen(page)}>
                                    <i className="bi bi-box-arrow-up-right" />
                                </button>
                                <button type="button" className="ops-demo-icon-btn" title={isCopied ? "コピーしました" : "URLをコピーします"} onClick={() => onCopy(page)}>
                                    <i className={"bi " + (isCopied ? "bi-check-lg" : "bi-copy")} />
                                </button>
                                <button type="button" className="ops-demo-icon-btn" title={page.is_locked ? "設定を確認します（ロック中のため変更・削除はできません）" : "設定変更・削除を行います"} onClick={() => onEdit(page)}>
                                    <i className={"bi " + (page.is_locked ? "bi-eye" : "bi-pencil")} />
                                </button>
                            </div>
                        </div>
                    );
                })}
                {!pages.length && <div className="ops-demo-list-empty">作成済みのデモページはありません。</div>}
            </div>
        }
    </div>
);

export default DemoPageList;
